export default function calculatePreviewScale(option) {
  const DPI = 72;
  if (
    option.preview_width > 0 &&
    option.preview_image_width_px > 0 &&
    option.preview_product_width_px > 0 &&
    option.product_width_inches > 0
  ) {
    const previewImageScale =
      option.preview_width / option.preview_image_width_px;
    const productImageScale =
      option.preview_product_width_px / DPI / option.product_width_inches;
    return previewImageScale * productImageScale;
  } else {
    return NaN;
  }
}
